import React from "react";
import dayjs from "dayjs";

function DateTimeLabel(props) {
  const { className, children, dateFormat } = props;
  let useDateFormat = "YYYY-MM-DD HH:mm:ss";

  if (dateFormat !== undefined && dateFormat !== null) {
    useDateFormat = dateFormat;
  }

  const dayjsDate = dayjs(children);

  return <p className={className}>{dayjsDate.format(useDateFormat)}</p>;
}

export default DateTimeLabel;
